//Initialize Accordion
new Accordion(".accordion-container");

//Carousel Script
//document.querySelectorAll(".glide__slides")
if (document.querySelector(".glide__slides")) {

  var allSlides = document.querySelectorAll(".glide");
  allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach((slide) => {

    const glide = new Glide(slide, {
      type: "slider",
      perView: 3,
      perTouch: 1,
      focusAt: 'center',
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: 'glide__arrow--disabled'
      },
      peek: {
        before: 100,
        after: 50
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          peek: 0
        }
      }
    }).mount();

  });
};

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
if (document.querySelector('.cta-btn')) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector('.cta-btn');
  let ctaLink = ctaBtn.getAttribute("href").split('/');

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
  }
}

//Menu
$(document).ready(function () {
  "use strict";
  $('.menu-main-menu-container > ul > li:has( > ul)').addClass('menu-dropdown-icon');
  $('.menu-main-menu-container > ul > li > ul:not(:has(ul))').addClass('normal-sub');
  $(".menu-main-menu-container > ul").before("<div class=\"container\"><span class=\"menu-span\">Menu</span><a href=\"#\" class=\"menu-mobile\"><span></span><span class=\"screen-reader-text\">Menu Toggle</span></a></div>");
  $(".menu-main-menu-container > ul > li").hover(function (e) {
    if ($(window).width() > 943  )  {
      if( $(this).children("ul").hasClass('sticky'))
      {

      }
      else{   
        $(".menu-main-menu-container > ul > li > ul").fadeOut(150);
        $(this).children("ul").stop(true, false).fadeIn(150).attr('aria-expanded', true);
      }

      e.preventDefault();
    }
  });

  $(".menu-main-menu-container > ul > li >ul >li").hover(function (e) {
    if ($(window).width() > 943) {
      $(this).children("ul").stop(true, false).fadeToggle(150).attr('aria-expanded', true);
      e.preventDefault();
    }
  });

  // $(".menu-main-menu-container > ul > li").on('mouseenter click', function (e) {
  //   if ($(window).width() > 943) {
  //     $(this).children("ul").stop(true, false).fadeIn(150).attr('aria-expanded', true).attr('aria-label');
  //     e.preventDefault();
  //   }
  // });
  // $(".menu-main-menu-container > ul > li").on('mouseleave', function (e) {
  //   if ($(window).width() > 943) {
  //     $(this).children("ul").stop(true, false).fadeOut(150).attr('aria-expanded', false);
  //     e.preventDefault();
  //   }
  // });
  $(".menu-main-menu-container > ul > li").click(function () {
    if ($(window).width() <= 943) {
      //$(this).children("ul").fadeToggle(150);
    }
  });
  $(".menu-mobile").click(function (e) {
    $(".menu-main-menu-container > ul").toggleClass('show-on-mobile');
    $(".menu-mobile").toggleClass('active-menu');
    $("#overlay").fadeToggle();
    $('body').toggleClass('no-scroll');

    if ($(".menu-mobile").hasClass('active-menu') == true) {
      var menuFromTop = $('.show-on-mobile').offset().top;
     $('.show-on-mobile').css('height', 'calc(100vh - ' + menuFromTop + 'px)');
    }

    e.preventDefault();
  });
});
$(window).resize(function () {
  $(".menu-main-menu-container > ul > li").children("ul").hide();
  $(".menu-main-menu-container > ul").removeClass('show-on-mobile');
});

let menuSubmenu = document.querySelectorAll('.menu-item-has-children');
let allmenuSubmenu = Array.prototype.slice.call(menuSubmenu);
var spanChevron = $('<span />').attr('class', 'arrowchevron').attr('tabindex', 0).attr('role', 'button').attr('aria-label', 'open submenu').html('');
$('.menu-item-has-children > a').append(spanChevron);

allmenuSubmenu.forEach((menu) => {

  let parentName = menu.firstChild.textContent;

  menu.children[0].setAttribute('aria-haspopup', 'true');
  menu.children[1].setAttribute('aria-expanded', false);
  //menu.children[1].setAttribute('aria-label', parentName + ' Submenu');
  //spanChevron.attr('aria-label', 'Open' + parentName + 'Submenu');
  let anchor = menu.children[0];
  anchor.children[0].setAttribute('aria-label', 'Open ' + parentName + ' Submenu');
});



$('.menu-item-has-children > a').on('click', function (e) {
  // console.log('link clicked');
  // if ($(this).next().css('display') == 'none') {
  //   e.preventDefault();
  //   $(this).closest('.arrowchevron').addClass('close-submenu');
  // } else {
  //   $(this).closest('.arrowchevron').removeClass('close-submenu');
  // }
})

$('.arrowchevron').on('keypress click', function (e) {
  //console.log('chevron clicked');
  var parentName = $(this).parent().text();

  $(this).parent().next().fadeToggle(150);
  $(this).toggleClass('close-submenu');

  if( $(this).hasClass('close-submenu')){
    $(this).attr('aria-label', 'close ' + parentName + ' submenu');
  } else {
    $(this).attr('aria-label', 'open ' + parentName + ' submenu');
  }

  // if ($(this).parent().next().css('display') == 'none') {
  //   $('.arrowchevron').addClass('close-submenu');
  // } else {
  //   $('.arrowchevron').removeClass('close-submenu');
  // }
  e.preventDefault();
});

////Pagination 
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll('.navigation-pagination ul li');

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

// if ($('.page-heading.only-desktop').length != 0) {
//   $('article.page').css('padding', 0);
// }

////////Glide
if (document.querySelector('.allcontainer')) {
  var elem = document.querySelector('.allcontainer');
  var msnry = new Masonry(elem, {
    // options
    itemSelector: '.item',
    columnWidth: '.grid-sizer',
    gutter: 15,
  });

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');    
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(document.querySelectorAll('.item'));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll('.filters button'); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;

    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function (block) {
      block.classList.remove('block');

      if (selectedValue == 'all') {
        block.classList.add('block');
      }

      if (block.getAttribute('data-cat') == selectedValue) {
        block.classList.add('block');
      }
    });
    msnry.layout();

    availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));
    document.getElementById('select').addEventListener("change", onSelectChange);

  }


  availableItems = Array.prototype.slice.call(document.querySelectorAll('.item.block'));

  document.getElementById('select').addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function (item) {
      item.classList.remove('block');

      if (selectedOption == 'all') {
        item.classList.add('block');
      }

      if (item.getAttribute('data-tag') == selectedOption) {
        item.classList.add('block');
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function () {
    //onclick
    $("#loadMore").on('click', function (e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data('page');
      var newPage = page + 1;
      var ajaxurl = that.data('url');
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: 'post',
        data: {
          page: page,
          action: 'ajax_script_load_more'

        },
        error: function (response) {
          console.log(response);
        },
        success: function (response) {
          //check
          if (response == 0) {
            $('.allcontainer').append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $('#loadMore').hide();
          } else {
            that.data('page', newPage);
            $('#ajax-primary').append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: '.item',
              columnWidth: '.grid-sizer',
              gutter: 15,
            });

            msnry.layout();
          }

        }
      });

    });
  });
}

$('#onetrust-group-container').on('click', 'button', function () {
  $('.skip-link').blur();
  $('.custom-logo-link').focus();
});

var navbar = document.getElementById("site-navigation");
var sticky = navbar.offsetTop;
var levelOne = $(".menu-main-menu-container>ul>li.current-menu-item"); 
var levelTwo = $(".menu-main-menu-container>ul>li>ul.sub-menu>li.current-menu-item"); 
var levelThree = $(".menu-main-menu-container>ul>li>ul>li>ul>li.current-menu-item"); 

var active =2 ;  
var submenu =levelTwo;
if(levelOne.length == 1)
{
  var active = 1;
  submenu =levelOne;
}
else if(levelTwo.length == 1)
{
  var active =2;
  submenu =levelTwo;
}
else if(levelThree.length == 1)
{
  var active =3;
  submenu =levelThree;
}



window.onscroll = function () { 
    if (window.pageYOffset >= sticky) {

      if (screen.width > 781){   
        
          if(active == 1)
          {                        
            $(".menu-main-menu-container>ul>li.current-menu-item>ul").css({"display": "block"});              
            $(".menu-main-menu-container>ul>li.current-menu-item>ul").addClass("sticky");   
          }
          else  if(active == 2)
          {
            $(submenu).parent('ul').css({"display": "block"});   
            $(submenu).parent('ul').addClass("sticky");   
          }
          else  if(active == 3)
          {
            $(".menu-main-menu-container>ul>li>ul>li>ul>li.current-menu-item").parent().parent().parent().css({"display": "block"});   
            $(".menu-main-menu-container>ul>li>ul>li>ul>li.current-menu-item").parent().parent().parent().addClass("sticky");  
          }         
      
      }
      else{
         navbar.classList.add("sticky");      
      }      
    } 
    else {
      if ( document.querySelector(".menu-mobile").classList.contains("active-menu"))
      {       
      }
      else{
        navbar.classList.remove("sticky"); 
        
        if(active == 1)
        {
         // $(".menu-main-menu-container>ul>li.current-menu-item>ul").css({"display": "none"});   
          $(".menu-main-menu-container>ul>li.current-menu-item>ul").removeClass("sticky");   
        }
        else  if(active == 2)
        {
          //$(submenu).parent('ul').css({"display": "none"});   
          $(submenu).parent('ul').removeClass("sticky");   
        }
        else  if(active == 3)
        {
         // $(".menu-main-menu-container>ul>li>ul>li>ul>li.current-menu-item").parent().parent().parent().css({"display": "none"});   
         $(".menu-main-menu-container>ul>li>ul>li>ul>li.current-menu-item").parent().parent().parent().removeClass("sticky");   
        }       
      }      
    }		                                                              
};

// for sub-menu closing on focus out
function closeAllSubmenu() {
	let allArrows = document.querySelectorAll(".arrowchevron");
	allArrows.forEach((ele) => {
		ele.classList.remove("close-submenu");
		ele.setAttribute("aria-label", "Open " + ele.parentElement.textContent + " submenu");
		let subM = ele.parentElement.nextElementSibling;
    // subM.classList.remove("open-submenu");
    subM.style.display='none';
    subM.setAttribute("aria-expanded", false);
  
	});
}

$(document).on('focusout', '.sub-menu', function (e) {
  setTimeout(function(){
      var focus=$(document.activeElement);
      if (focus.is(".sub-menu") || $('.sub-menu').has(focus).length) {
      } else {
        closeAllSubmenu();

      }
  },0);
});

//for main-menu closing on mobile
let openMobileNav = (e) => {
    $(".menu-main-menu-container > ul").toggleClass('show-on-mobile');
    $(".menu-mobile").toggleClass('active-menu');
    if (window.innerWidth <= 960) {
    $("#overlay").fadeToggle();
    $('body').toggleClass('no-scroll');
  }
    if ($(".menu-mobile").hasClass('active-menu') == true) {
      var menuFromTop = $('.menu-main-menu-container').offset().top;
      if (window.innerWidth <= 960) {
      $('.menu-main-menu-container').css('height', 'calc(100vh - ' + menuFromTop + 'px)');
      }
    }

};


$(document).on('focusout', '#primary-menu', function (e) {
  setTimeout(function(){
      var focus=$(document.activeElement);
      if (focus.is("#primary-menu") || $('#primary-menu').has(focus).length) {
      } else {
        openMobileNav();
      }
  },0);
});


document.addEventListener('DOMContentLoaded', function() {
  const iframe = document.getElementById('vimeo-iframe');
  const player = new Vimeo.Player(iframe);
  const muteButton = document.getElementById('mute-button');

  muteButton.addEventListener('click', function() {
    const buttonText = muteButton.textContent;
    if(buttonText !== 'Mute'){
      player.setVolume(1).then(function() {
        muteButton.textContent = 'Mute'; // Change button text
    });
    } else {
      player.setVolume(0).then(function() {
        muteButton.textContent = 'Unmute'; // Change button text
    });
    }
   
      // player.getVolume().then(function(volume) {
      //     if (volume > 0) {
      //         player.setVolume(0).then(function() {
      //             muteButton.textContent = 'Mute'; // Change button text
      //         });
      //     } else {
      //         player.setVolume(1).then(function() {
      //             muteButton.textContent = 'Unmute'; // Change button text
      //         });
      //     }
      // }).catch(function(error) {
      //     console.error('Error getting volume:', error);
      // });
  });
});

